import { render, staticRenderFns } from "./draggable.vue?vue&type=template&id=f65fb1ba"
import script from "./draggable.vue?vue&type=script&lang=js"
export * from "./draggable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f65fb1ba')) {
      api.createRecord('f65fb1ba', component.options)
    } else {
      api.reload('f65fb1ba', component.options)
    }
    module.hot.accept("./draggable.vue?vue&type=template&id=f65fb1ba", function () {
      api.rerender('f65fb1ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/postCreator/components/storyTab/storyMaker/draggable.vue"
export default component.exports